import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { StyledWrapper, StyledText } from '../UnavailableByBooking/UnavailablebyBooking.styles';
import { StyledContainer } from '../UnavailableSeat.styles';

const UnavailableAsBlocked = ({ seats }) => (
  <StyledContainer data-testid="unavailable-blocked">
    <StyledWrapper>
      <StyledText>
        <FormattedMessage id="unavailableSeats.blockedSeats" />{' '}
      </StyledText>
      <strong>{seats.map(({ seat }) => `${seat},`)}</strong>
    </StyledWrapper>
  </StyledContainer>
);

UnavailableAsBlocked.propTypes = {
  seats: PropTypes.arrayOf(
    PropTypes.shape({
      seat: PropTypes.string
    })
  )
};

export default UnavailableAsBlocked;
